import React from "react";
import "../css/serviciosAdicionales.scss";
import Breadcrumbs from './Breadcrumbs';
import Footer from "./Footer";
import restaurante from "../assets/images/serviciosAdicionales/restaurante.jpg";
import asientos from "../assets/images/serviciosAdicionales/sala-asientos-VIP.png";
import capsula from "../assets/images/serviciosAdicionales/sleeping-pods.jpg";
import auto from "../assets/images/serviciosAdicionales/auto.png";

const ServiciosAdicionales = () => {
  return (
<>


<section className="entretenimiento">
         {/* HERO */}
                <div className='entretenimiento-hero'>
                    <div className='overlay'></div>

                    <div className='container'>
                        <div className='hero-content'>

                            <div style={{ marginTop: '4rem' }} style={{ color: '#fff' }}>
                                <Breadcrumbs />
                            </div>

                            <h1>Servicios Adicionales</h1>

                            <p>
                                Infórmate sobre los servicios y comodidades para disfrutar al máximo tu viaje.
                            </p>

                        </div>
                    </div>
                </div>

      </section>
      
      
      

    <main className="servicios-page">
   
      {/* =========================
          SERVICIOS PRINCIPALES
      ========================== */}
      <section className="servicios-grid">

        {/* Internet */}
        <article className="servicio-card">
          <div>
            <div className="servicio-icon">
              <span className="material-symbols-outlined">
                wifi
              </span>
            </div>

            <h3>Internet a bordo</h3>

            <p>
              Mantente conectado durante toda tu travesía marítima.
              Ofrecemos paquetes de conectividad satelital para que
              puedas navegar, revisar correos o comunicarte con tus
              seres queridos.
            </p>
          </div>
        </article>


        {/* Viaja con tu auto */}
        <article className="servicio-card servicio-card-large">
          <div className="servicio-decoration"></div>

          <div className="servicio-content">
            <div className="servicio-icon">
              <span className="material-symbols-outlined">
                directions_car
              </span>
            </div>

            <h3>Viaja con tu auto</h3>

            <p>
              La mayor comodidad de viajar por mar es llevar tu propio
              vehículo. Desde autos compactos hasta SUVs, tenemos el
              espacio perfecto para que tu viaje continúe sin problemas.
            </p>

            
            <a href="https://www.bajaferries.com.mx/tarifas" rel="noopener noreferrer" target="_blank" aria-label="Ver tarifas">Ver tarifas</a> 
          </div>

          <div className="servicio-image">
            <img
              src={auto}
              alt="Vehículo dentro del ferry"
            />
          </div>
        </article>


        {/* Asiento VIP */}
        <article className="servicio-card servicio-card-large vip-card">

          <div className="servicio-content">
            <div className="servicio-icon">
              <span className="material-symbols-outlined">
                event_seat
              </span>
            </div>

            <h3>Asiento VIP / Especial</h3>

            <p>
              Disfruta del máximo confort en nuestros salones
              exclusivos. Asientos reclinables ergonómicos, mayor
              espacio para las piernas y ambiente climatizado.
            </p>

            <a href="https://www.bajaferries.com.mx/tarifas" rel="noopener noreferrer" target="_blank" aria-label="Ver tarifas">Ver tarifas</a> 
          </div>

          <div className="servicio-image">
            <img
              src={asientos}
              alt="Asientos VIP del ferry"
            />
          </div>
        </article>


        {/* Cabinas */}
        <article className="servicio-card">
          <div>
            <div className="servicio-icon">
              <span className="material-symbols-outlined">
                bed
              </span>
            </div>

            <h3>Cabinas Privadas</h3>

            <p>
              Descansa en total privacidad. Nuestras cabinas 
              ofrecen literas confortables, baño privado y el ambiente
              perfecto para relajarte antes de llegar a tu destino.
            </p>
          </div>

          <a href="https://www.bajaferries.com.mx/tarifas" rel="noopener noreferrer" target="_blank" aria-label="Ver tarifas">Ver tarifas</a> 
        </article>

      </section>


      {/* =========================
          CABINAS CABO STAR
      ========================== */}
      <section className="detalle-section detalle-cabinas">

        <div className="detalle-grid">

          <div className="detalle-content">

            <span className="badge">
              Exclusivo Cabo Star
            </span>

            <h2>
              Cabinas de Descanso
              <span> (Sleeping Pods)</span>
            </h2>

            <p className="detalle-description">
              Una opción innovadora para el viajero práctico.
              Nuestras cápsulas de descanso en el buque Cabo Star
              ofrecen un espacio personal y optimizado para dormir
              confortablemente durante la travesía.
            </p>

            <ul className="check-list">

              <li>
                <span className="material-symbols-outlined">
                  check_circle
                </span>

                <span>
                  Diseño ergonómico y moderno tipo cápsula.
                </span>
              </li>

              <li>
                <span className="material-symbols-outlined">
                  check_circle
                </span>

                <span>
                  Iluminación individual y puertos de carga USB.
                </span>
              </li>

              <li>
                <span className="material-symbols-outlined">
                  check_circle
                </span>

                <span>
                  Áreas de baño compartidas.
                </span>
              </li>

            </ul>

            <a href="https://www.bajaferries.com.mx/servicios-cabo-star" rel="noopener noreferrer" target="_blank" aria-label="Ver tarifas">Conoce el Cabo Star</a> 

            

          </div>

          <div className="detalle-image">
            <img
              src={capsula}
              alt="Cabinas de descanso tipo cápsula"
            />
          </div>

        </div>

      </section>


      {/* =========================
          RESTAURANTE Y BAR
      ========================== */}
      <section className="restaurante-section">

        <div className="restaurante-grid">

          <div className="restaurante-image">
            <img
              src={restaurante}
              alt="Restaurante a bordo"
            />
          </div>

          <div className="restaurante-content">

            <div className="restaurante-icon">
              <span className="material-symbols-outlined">
                restaurant
              </span>
            </div>

            <h2>
              Restaurante y Bar a Bordo
            </h2>

            <p>
              Disfruta de una excelente propuesta gastronómica
              mientras navegas. Contamos con opciones para todos
              los antojos, garantizando calidad y frescura en cada
              bocado.
            </p>

            <div className="food-options">

              <div className="food-card snacks">
                <h4>Venta de Snacks</h4>

                <p>
                  Disponibles a la carta. Papas fritas, alitas,
                  postres y bebidas refrescantes para acompañar
                  tu viaje.
                </p>
              </div>

              <div className="food-card snacks">
                <h4>Comida Formal</h4>

                <p>
                  Platillos completos servidos en horarios
                  específicos según tu ruta, ideales para recargar
                  energías.
                </p>
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =========================
          BICICLETA + MASCOTA
      ========================== */}
      <section className="extras-section">

        <div className="extra-column">

          <div className="servicio-icon">
            <span className="material-symbols-outlined">
              pedal_bike
            </span>
          </div>

          <h3>
            Viaje con Bicicleta
          </h3>

          <p>
            Fomentamos la movilidad sustentable. Puedes viajar con
            tu bicicleta a bordo de nuestras embarcaciones,
            asegurando que esté debidamente resguardada en las
            áreas designadas durante la travesía.
          </p>
          

        </div>


        <div className="extra-column">

          <div className="servicio-icon">
            <span className="material-symbols-outlined">
              pets
            </span>
          </div>

          <h3>
            Viaje con Mascota
          </h3>

          <p>
            Tus compañeros de cuatro patas son bienvenidos.
            Contamos con áreas específicas y opciones de cabinas
            pet-friendly para que viajen cómodos y seguros.
          </p>


          <div className="pet-service">

            <span className="material-symbols-outlined">
              medical_services
            </span>

            <div>
              <h4>Mascota de Servicio</h4>

              <p>
                Viajan sin costo presentando el certificado
                oficial correspondiente.
              </p>
            </div>

          </div>


          <div className="important-notes">

            <h4>
              Notas Importantes
            </h4>

            <ul>

              <li>
                <span className="material-symbols-outlined">
                  info
                </span>

                <span>
                  Mascotas pequeñas deberán viajar en
                  transportadora.
                </span>
              </li>

              <li>
                <span className="material-symbols-outlined">
                  info
                </span>

                <span>
                  Razas grandes deberán permanecer con correa
                  y bozal.
                </span>
              </li>

              <li>
                <span className="material-symbols-outlined">
                  info
                </span>

                <span>
                  Deben permanecer en el área asignada
                  (transportadora o cabina pet friendly).
                </span>
              </li>

            </ul>

          </div>

        </div>

      </section>

      

    </main>
    <Footer />
    </>
  );
};

export default ServiciosAdicionales;